<template>
  <VApp>
    <VAppBar color="primary">
      <VRow align="center" class="px-4">
        <VBtn prepend-icon="fak fa-bisom" color="white" size="large" class="ml-2" readonly>
          BISOM
        </VBtn>
        <VSpacer />

        <span class="mr-2 text-uppercase">
          {{ $t("pageTitles." + $route.name) }}
        </span>
      </VRow>
    </VAppBar>

    <router-view class="pt-15" />
  </VApp>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PublicLayout",
});
</script>
